<template>
  <v-container v-if="details !== null">
    <h3 class="secondary--text mt-5">Booking Details</h3>
    <hr class="hor">
    <v-card class="pa-5 mt-5">
      <v-row class="">
        <v-simple-table dense style="width: 100%;">
          <template v-slot:default>
            <thead>
                <tr>
                  <th class="text-left">PNR</th>
                  <th class="text-left">Booking Date</th>
                  <th class="text-left">Status</th>
                  <th class="text-left">Price</th>
                  <th class="text-left">Settings</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ details.booking_reference }}</td>
                    <td>{{ formatDateTime(details.booking_date)}}</td>
                    <td>{{ details.status }}</td>
                    <td>${{ details.price }}</td>
                    <td>
                      <v-btn v-if=" details.status === 'Initial'" @click="qoutePnr" small elevation="0" tile color="blueDark white--text" class="mt-1" :loading="loadingQuotePnr">
                        issue Pnr
                      </v-btn>
                      <v-dialog max-width="800" v-model="qouteReservedPnr" persistent>
                        <v-card>
                          <v-card-title class="text-blueDark">Confirm PNR</v-card-title>
                          <v-divider class="mx-2"/>
                          <v-card-text>
                            <div class="d-flex justify-space-between rounded">
                              <span class=" font-weight-bold"> Total Price</span>
                              <span class=" font-weight-bold"> {{ price }} {{ currency }}</span>
                            </div>
                          </v-card-text>
                        <v-divider class="mx-2"/>
                        <v-card-text>
                          <h3>Payment Method</h3>
                            <v-radio-group v-model="paymentMethodForConfirm"  row>
                              <v-radio label="Cash" value="cash" color="darkBlue" />
                              <v-radio label="Credit Card" value="card" color="darkBlue" />
                            </v-radio-group>
                        </v-card-text>
                        <v-card-text>
                     <v-expand-transition>
                      <v-form v-if="paymentMethodForConfirm === 'card'">
                        <v-row>
                          <v-col cols="12" md=6>
                          <v-text-field
                            prepend-inner-icon="mdi-credit-card-outline"
                            v-model="cardNum"
                            :rules="cardRules"
                            label="Card number"
                            required
                            outlined
                            type="number"
                            color="blueDark"
                          />
                          </v-col>
                          <v-col cols="12" md=6>
                           <v-text-field
                             v-model="cardName"
                             :rules="cardNameRules"
                             label="Card Holder Name"
                             required
                             outlined
                             class="remove-controls"
                             type="text"
                             color="blueDark"
                            />
                          </v-col>
                        </v-row>
                      <v-row class="mt-n9">
                        <v-col cols="6">
                          <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            min-width="290px"
                          >
                          <template v-slot:activator="{ on }">
                           <v-text-field
                             outlined
                             :rules="requiredRule"
                             label="Card expire Date"
                             readonly
                             color="blueDark"
                             v-on="on"
                             prepend-inner-icon="mdi-calendar"
                             v-model="cardExpireDateText"
                            />
                          </template>
                        <v-date-picker
                          color="indigo"
                          :min="new Date().toISOString().substr(0, 10)"
                          v-model="cardExpireDate"
                          type="month"
                          @input="menu = false"
                        />
                          </v-menu>
                        </v-col>
                        <v-col cols="6">
                           <v-text-field
                             v-model="cvv"
                             :rules="cvvRules"
                             label="CVV"
                             required
                             outlined
                             type="number"
                             color="blueDark"
                            />
                        </v-col>
                      </v-row>
                      <v-row >
                        <v-col cols="12" md=6>
                          <v-autocomplete
                            v-model="country"
                            label="Country"
                            :items="countries"
                            outlined
                            item-text="name"
                            return-object
                            variant="outlined"
                            :rules="requiredRule"
                          />
                        </v-col>
                        <v-col cols="12" md=6>
                          <v-text-field
                            v-model="state"
                            outlined
                            placeholder="State"
                            :rules="requiredRule"
                          />
                        </v-col>
                      </v-row>
                      <v-row >
                        <v-col cols="12" md=6>
                            <v-text-field
                              v-model="city"
                              outlined
                              placeholder="City"
                              :rules="requiredRule"
                            />
                        </v-col>
                        <v-col cols="12" md=6>
                            <v-text-field
                              v-model="zipCode"
                              outlined
                              placeholder="postal code"
                             :rules="requiredRule"
                            />
                           </v-col>
                          <v-col cols="12" md=6>
                            <v-text-field
                              v-model="street"
                              outlined
                              placeholder="street"
                              :rules="requiredRule"
                            />
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-expand-transition>
                   </v-card-text>
                <v-card-actions>
                   <v-btn color="warning" @click="qouteReservedPnr = false">Close</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="blueDark" class="white--text" @click="confirmPnr" :loading="loadingConfirmPnr">Confirm</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
                      <!-- refund pnr -->
                      <v-btn v-if="details.status === 'E-ticketed' || details.status === 'Exchanged'"  @click="preConfirmRefundDialog = true" small elevation="0" tile color="blueDark white--text" class="mt-1 ms-3">
                        Refund
                      </v-btn>
                       <v-dialog max-width="500" v-model="preConfirmRefundDialog" persistent>
                         <v-card>
                           <v-card-title class="text-center">Are You Sure You Want to Refund This Booking?</v-card-title>
                           <v-card-actions>
                             <v-btn @click="preConfirmRefundDialog = false" color="warning">close</v-btn>
                             <v-spacer/>
                             <v-btn @click="confirmRefundPnr()" :loading="preConfirmBtnLoading" color="blueDark" class="white--text" >Confirm</v-btn>
                           </v-card-actions>
                        </v-card>
                       </v-dialog>
                        <v-dialog max-width="500" v-model="confirmRefundDialog" persistent>
                         <v-card v-if="refundResponse">
                           <v-card-title class="text-center text-blueDark">Refund Summery</v-card-title>
                           <v-divider class="mx-5"/>
                           <v-card-text v-if="refundResponse.ndc.refundAmount">
                            <div class="d-flex justify-space-between">
                              <span class="text-blueDark font-weight-bold"> Refund Amount</span>
                              <span>{{ refundResponse.ndc.refundAmount.price }} {{ refundResponse.ndc.refundAmount.currency }}</span>
                            </div>
                           </v-card-text>
                           <v-divider class="mx-5"/>
                           <v-card-text>
                             <div v-if="refundResponse.ndc.baseFare" class="d-flex justify-space-between">
                               <span> Base Fare</span>
                               <span>{{ refundResponse.ndc.baseFare.price }} {{ refundResponse.ndc.baseFare.currency }}</span>
                              </div>
                              <div v-if="refundResponse.ndc.taxes" class="d-flex justify-space-between">
                                <span> Taxes: </span>
                                <span>{{ refundResponse.ndc.taxes.price }} {{ refundResponse.ndc.taxes.currency }}</span>
                              </div>
                            </v-card-text>
                            <v-divider class="mx-5" />
                            <v-card class="mx-5 rounded-lg" variant="outlined">
                              <v-card-text>
                                <v-row>
                                  <v-col cols="3">
                                   Traveller
                                  </v-col>
                                  <v-col cols="2">
                                   Base Fare
                                  </v-col>
                                  <v-col cols="2" class="text-right">
                                    Taxes
                                  </v-col>
                                  <v-col cols="2" class="text-right">
                                   Total
                                  </v-col>
                                  <v-col cols="3" class="text-right">
                                    Due by airline
                                  </v-col>
                                 </v-row>
                                 <v-divider/>
                                 <v-row v-for="(offer ,index) in  refundResponse.ndc.passengerRefunds" :key="index">
                                   <v-col cols="3">
                                     Passenger {{ index+1 }}
                                   </v-col>
                                   <v-col cols="2">
                                     {{ offer.baseFare }}
                                   </v-col>
                                   <v-col cols="2" class="text-right">
                                    {{ offer.taxes }}
                                   </v-col>
                                   <v-col cols="2" class="text-right">
                                     {{ offer.total }}
                                   </v-col>
                                   <v-col cols="3" class="text-right">
                                     {{ offer.dueByAirline }}
                                   </v-col>
                                  </v-row>
                                </v-card-text>
                               </v-card>
                               <v-divider class="mx-5"/>
                               <v-card-text>
                                 By confirming, you agree to process this refund.
                                 The refund amount will be returned to your original payment method.
                               </v-card-text>
                               <v-divider class="mx-5"/>
                               <v-card-actions>
                                 <v-btn @click="confirmRefundDialog = false" variant="flat" color="warning" >close</v-btn>
                                 <v-btn :loading="loadingRefund" variant="flat" color="blueDark" class="white--text" @click="refundPnr">confirm</v-btn>
                               </v-card-actions>
                              </v-card>
                        </v-dialog>
                      <v-btn  v-if="details.status === 'E-ticketed' || details.status === 'Exchanged'" @click="checkValibility" small elevation="0" tile color="blueDark white--text" class="mt-1 ms-3" :loading="checkAvalibiltyLoading">
                        EXchange
                      </v-btn>
                      <v-dialog max-width="1000" v-model="searchDialog" persistent>
                        <v-card v-if="journeys.length">
                          <v-container>
                            <v-row>
                            <!-- LEFT: Current Itinerary -->
                              <v-col v-if="validJourneys.length>1" cols="12" md="4">
                                <h3 class="mb-4">Current Itinerary</h3>
                                <!-- Outbound -->
                                <v-card
                                  v-for="(trip, index) in validJourneys"
                                  :key="trip.journeyId"
                                  class="mb-4"
                                >
                                  <div v-if="(deletedFlight !== index || deletedFlight=== null)">
                                    <v-card-title class="text-primary"> {{trip.journeyId}} Flight</v-card-title>
                                    <v-card-text>
                                      <div class="d-flex flex-column">
                                        <span>{{ trip.displayName }}</span>
                                      </div>
                                    </v-card-text>
                                    <v-card-actions>
                                      <v-btn :disabled="deletedFlight !== null " color="error" outlined @click="deleteFlight(trip.journeyId,index)">
                                        Delete Flight
                                      </v-btn>
                                    </v-card-actions>
                                  </div>
                                </v-card>
                              </v-col>
                              <v-col cols="12" md="8">
                                <h3 class="mb-4">Exchange Trip</h3>
                                <p class="text-grey mb-3">Select an action:</p>
                                <v-radio-group v-model="selectedAction" color="blueDark" >
                                <!-- Modify Outbound -->
                                 <div v-for="(trip, index) in validJourneys" :key="trip.journeyId" >
                                   <v-card v-if="(deletedFlight !== index || deletedFlight === null )" class="mb-3 pa-2" >
                                    <v-radio :value="index=== 0 ? 'going' : 'return'">
                                      <template #label>
                                  <div>
                                    <strong>Modify {{ trip.journeyId }} Flight</strong>
                                    <div class="text-caption text-grey">
                                     {{ trip.displayName }}
                                    </div>
                                  </div>
                                </template>
                              </v-radio>
                            </v-card>
                          </div>
                          <!-- Modify Round -->
                          <v-card v-if="validJourneys.length > 1 && deletedFlight === null"  class="mb-3 pa-2">
                            <v-radio value="round">
                            <template #label>
                              <div>
                                <strong>Modify Going & Return Flight</strong>
                                <div class="text-caption text-grey">
                                  {{ validJourneys[0].displayName + ',  ' + validJourneys[1].displayName }}
                                </div>
                              </div>
                            </template>
                          </v-radio>
                        </v-card>
                        <!-- Change Dates & routes -->
                        <v-card v-if="selectedAction !==null" class="pa-2">
                          <v-card-title>Change Routes or Dates</v-card-title>
                          <v-card-text>
                            <v-row>
                              <v-col>
                                <h4 class="mb-2">Depature</h4>
                                <cities type="Departure"></cities>
                                <picker v-if="selectedAction === 'round'" type="Departure Date" date-placeholder="Departure Date"></picker>
                              </v-col>
                              <v-col>
                                <h4 class="mb-2">Return</h4>
                                 <cities type="Arrival" @setSecondDeparture="setSecondDeparture"></cities>
                                 <picker  v-if="selectedAction === 'round'" type="Arrival Date" date-placeholder="Arrival Date" ></picker>
                              </v-col>
                          </v-row>
                           <v-row v-if="selectedAction !== 'round'">
                            <v-col>
                              <picker type="Departure Date" date-placeholder="Departure Date"/>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                      </v-radio-group>
                      <!-- CONTINUE BUTTON -->
                      <v-btn
                        color="darkBlue"
                        size="large"
                        block
                        class="mt-2 white--text"
                        :loading="searchFlightLoading"
                        @click="searchFlights"
                      >
                        Continue
                      </v-btn>
                      <v-btn
                        color="warning"
                        size="large"
                        block
                        class="mt-2"
                        @click="cancelSearch"
                      >
                        cancel
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
                      </v-dialog>
                      <v-dialog  max-width="1500" v-model="searchResultDialog" persistent>
                         <v-card class="pa-5">
                           <exchange-flight-card
                             :flights="flightResult"
                             :replaceFlight="journeys_replace"
                             :deleteFlights="journeys_cancel"
                             :pnr="details.booking_reference"
                             :paxsId="paxIds"
                             @selectFlight="selectFlight"
                           />
                         </v-card>
                      </v-dialog>
                      <v-dialog max-width="800" v-model="quoteExchangeDialog">
                        <v-card v-if="newOffer" class="pa-5 rounded-xl" elevation="2">
                          <v-card-title class="text-h6 font-weight-bold">
                            Flight Change Summary
                          </v-card-title>
                          <v-divider class="my-3" />
                          <v-row class="mb-4">
                            <v-col cols="12">
                             <v-alert
                              tonal
                              type="info"
                              class="rounded-lg"
                            >
                              <div class="d-flex justify-space-between align-center">
                                <span class="text-subtitle-1 font-weight-medium">
                                  Total Due to Airline
                                 </span>
                                <span class="text-h6 text-primary font-weight-bold">
                                  {{  newOffer.dueToAirline }} {{ newOffer.dueCurrency }}
                                </span>
                              </div>
                            </v-alert>
                          </v-col>
                        </v-row>
                        <v-card
                          class="mb-4 rounded-lg"
                          outlined
                        >
                          <v-card-text>
                           <v-row>
                              <v-col cols="3">
                               Traveller
                              </v-col>
                              <v-col cols="2">
                               Base Fare
                              </v-col>
                              <v-col cols="2" class="text-right">
                                Taxes
                              </v-col>
                              <v-col cols="2" class="text-right">
                                Total
                              </v-col>
                              <v-col cols="3" class="text-right">
                                Due to airline
                              </v-col>
                            </v-row>
                            <v-divider/>
                            <v-row v-for="(offer ,index) in  newOffer.fareDetails" :key="index">
                              <v-col cols="3">
                                Passenger {{ index+1 }}
                              </v-col>
                              <v-col cols="2">
                               {{ offer.baseFare }}
                              </v-col>
                              <v-col cols="2" class="text-right">
                               {{ offer.taxes }}
                              </v-col>
                              <v-col cols="2" class="text-right">
                                {{ offer.total }}
                              </v-col>
                              <v-col cols="3" class="text-right">
                                {{ offer.dueToAirline }}
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                        <v-alert
                          type="info"
                          tonal
                          class="rounded-lg"
                        >
                          <div class="d-flex justify-space-between align-center">
                            <span>
                              You need to pay the fare difference to confirm the exchange
                            </span>
                          </div>
                        </v-alert>
                        <v-card-text>
                          <h3 class="text-primary">Payment Method</h3>
                          <v-radio-group v-model="paymentMethod" color="darkBlue" row>
                            <v-radio label="Cash" value="cash" color="darkBlue" />
                            <v-radio label="Credit Card" value="card" color="darkBlue" />
                          </v-radio-group>
                        </v-card-text>
                        <v-card-text class="mt-n10">
                          <v-expand-transition>
                            <v-form v-if="paymentMethod === 'card'">
                              <v-row>
                                <v-col cols="12" md=6>
                                <v-text-field
                                  prepend-inner-icon="mdi-credit-card-outline"
                                  v-model="cardNumOfExchangr"
                                  :rules="cardRules"
                                  label="Card number"
                                  required
                                  outlined
                                  type="number"
                                  color="blueDark"
                                />
                              </v-col>
                              <v-col cols="12" md=6>
                                <v-text-field
                                  v-model="cardNameOfExchange"
                                  :rules="cardNameRules"
                                  label="Card Holder Name"
                                  required
                                  outlined
                                  class="remove-controls"
                                  type="text"
                                  color="blueDark"
                                 />
                               </v-col>
                              </v-row>
                               <v-row class="mt-n9">
                                 <v-col cols="6">
                                   <v-menu
                                     v-model="menuOfExchange"
                                     :close-on-content-click="false"
                                     transition="scale-transition"
                                     min-width="290px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                        outlined
                                        :rules="requiredRule"
                                        label="Card expire Date"
                                        readonly
                                        color="blueDark"
                                        v-on="on"
                                        prepend-inner-icon="mdi-calendar"
                                        v-model="cardExpireDateTextOfExchange"
                                      />
                                    </template>
                                    <v-date-picker
                                      color="indigo"
                                      :min="new Date().toISOString().substr(0, 10)"
                                      v-model="cardExpireDateOfExchange"
                                      type="month"
                                      @input="menu = false"
                                    />
                                  </v-menu>
                                </v-col>
                              <v-col cols="6">
                                <v-text-field
                                  v-model="cvvOfExchange"
                                  :rules="cvvRules"
                                  label="CVV"
                                  required
                                  outlined
                                  type="number"
                                  color="blueDark"
                                />
                              </v-col>
                            </v-row>
                            <v-row >
                              <v-col cols="12" md=6>
                                <v-autocomplete
                                  v-model="countryOfExchange"
                                  label="Country"
                                  :items="countries"
                                  outlined
                                  item-text="name"
                                  return-object
                                  variant="outlined"
                                  :rules="requiredRule"
                                />
                              </v-col>
                              <v-col cols="12" md=6>
                               <v-text-field
                                 v-model="stateOfExchnage"
                                 outlined
                                 placeholder="State"
                                :rules="requiredRule"
                              />
                            </v-col>
                          </v-row>
                          <v-row >
                            <v-col cols="12" md=6>
                              <v-text-field
                                v-model="cityOfExchange"
                                outlined
                                placeholder="City"
                                :rules="requiredRule"
                              />
                            </v-col>
                            <v-col cols="12" md=6>
                              <v-text-field
                                v-model="zipCodeOfExchange"
                                outlined
                                placeholder="postal code"
                                :rules="requiredRule"
                              />
                              </v-col>
                              <v-col cols="12" md=6>
                                <v-text-field
                                  v-model="streetOfExchange"
                                  outlined
                                 placeholder="street"
                                 :rules="requiredRule"
                                />
                              </v-col>
                            </v-row>
                          </v-form>
                         </v-expand-transition>
                       </v-card-text>
                       <v-divider class="my-4" />
                       <v-row justify="end">
                         <v-btn outlined class="mr-3" @click="quoteExchangeDialog = false">
                          Cancel
                        </v-btn>
                        <v-btn color="darkBlue" class="white--text" :loading="loadingConfirmExchange" @click="confirmOffer">
                         Confirm Change
                        </v-btn>
                       </v-row>
              </v-card>
                      </v-dialog>
                       <v-dialog v-model="confirmExchangeDialog" max-width="700">
                         <v-card v-if="newFlight">
                         <v-card-title class="font-weight-bold darkBlue--text">
                           Confirm Exchange
                         </v-card-title>
                         <v-card-text>
                           <p><strong>Order ID:</strong> {{ newFlight.orderId }}</p>
                           <v-alert type="info" tonal class="my-3">Exchange Payment:<strong>
                            {{ newFlight.exchangePayment.currency }}
                            {{ newFlight.exchangePayment.price }}
                            </strong>
                           </v-alert>
                           <div v-for="ticket in newFlight.newTickets" :key="ticket.ticketNumber">
                             <p><strong>Passenger:</strong> {{ ticket.passengerName }}</p>
                             <p><strong>Ticket Number:</strong> {{ ticket.ticketNumber }}</p>
                             <v-divider class="my-2" />
                             <p class="font-weight-bold">New Flights</p>
                             <v-list density="compact">
                               <v-list-item
                                 v-for="(flight, index) in ticket.flightsSummary"
                                 :key="index"
                                >
                                  <v-list-item-title>
                                   ✈️ {{ flight.departureLocationCode }} →
                                       {{ flight.arrivalLocationCode }}
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                    {{ flight.carrier }} {{ flight.flightNumber }} |
                                    {{ flight.departureDateTime }} → {{ flight.arrivalDateTime }}
                                  </v-list-item-subtitle>
                                </v-list-item>
                              </v-list>
                            </div>
                          </v-card-text>
                          <v-card-actions class="justify-end">
                          <v-btn color="darkBlue" class="white--text" @click="confirmExchangeDialog = false">
                            Finish
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
          </td>
        </tr>
      </tbody>
     </template>
    </v-simple-table>
  </v-row>
</v-card>

    <h3 class="secondary--text mt-5">Contact Person Details</h3>
    <hr class="hor">
    <v-card class="pa-5 mt-5">
      <v-row class="">
        <v-simple-table dense style="width: 100%;">
          <template v-slot:default>
            <thead>
                <tr>
                    <th class="text-left">Name</th>
                    <th class="text-left">Email</th>
                    <th class="text-left">Phone</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ details.contact_person }}</td>
                    <td>{{ details.contact_email }}</td>
                    <td>{{ details.contact_phone }}</td>
                </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-row>
    </v-card>

    <h3 class="secondary--text mt-5">Passengers Details</h3>
    <hr class="hor">
    <v-card class="pa-5 mt-5">
      <v-row class="">
        <v-simple-table dense style="width: 100%;">
            <template v-slot:default>
              <thead>
                  <tr>
                      <th class="text-left">Name</th>
                      <th class="text-left">Birth Date</th>
                      <th class="text-left">Passport</th>
                      <th class="text-left">Passport Expire Date</th>
                      <th class="text-left">Issue Country</th>
                      <th class="text-left">Ticket</th>
                      <th class="text-left">settings</th>
                  </tr>
              </thead>
              <tbody>
                  <tr v-for="passenger in details.passenger_details" :key="passenger.id">
                      <td>{{ passenger.passenger_name }}</td>
                      <td>{{ formatDateTime(passenger.date_of_birth) }}</td>
                      <td v-if="passenger.passport_number">{{ passenger.passport_number }}</td>
                      <td v-else>--</td>
                      <td v-if="passenger.passport_expire_date">{{ formatDateTime(passenger.passport_expire_date) }}</td>
                      <td v-else>--</td>
                      <td v-if="passenger.passport_issue_country">{{ passenger.passport_issue_country }}</td>
                      <td v-else>--</td>
                      <td>{{ passenger.ticket_number ? passenger.ticket_number : 'Not ticketed yet' }}</td>
                      <td class="text-left">
                        <v-btn text x-small color="blueDark" @click="openPassportForm(passenger)">manage passport</v-btn>
                      </td>
                  </tr>
              </tbody>
            </template>
        </v-simple-table>
      </v-row>
    </v-card>

    <v-dialog v-model="passportFormDialog">
      <v-card v-if="passengerInfo" class="pa-5">
        <v-card-title>Update passport informaton</v-card-title>
        <v-form v-model="validPassport" ref="passportForm">
          <v-text-field
          v-model="passengerInfo.passport_number"
          label="Passport Number"
          prepend-inner-icon="mdi-passport"
          outlined
          :rules="[
            v => !!v || 'Passport number is required',
            v => v && v.length <= 15 || 'Maximum number of characters is 15',
            v => v && v.length >= 5 || 'Minimum number of characters is 5'
          ]"
          persistent-hint
          color="blueDark"
          id="passenger-passport-num"
          ></v-text-field>
           <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            min-width="290px"
                          >
                          <template v-slot:activator="{ on }">
                           <v-text-field
                             outlined
                             :rules="requiredRule"
                             label="passport Expiry Date"
                             readonly
                             color="blueDark"
                             v-on="on"
                             prepend-inner-icon="mdi-calendar"
                             v-model="passengerInfo.passport_expire_date"
                            />
                          </template>
                        <v-date-picker
                          color="indigo"
                          :min="new Date().toISOString().substr(0, 10)"
                          v-model="passengerInfo.passport_expire_date"
                          @input="menu2 = false"
                        />
                          </v-menu>
          <span class="caption grey--text">Hint: MM/DD/YYYY</span>

          <v-autocomplete
          v-model="passengerInfo.passport_issue_country"
          :items="countries"
          item-text="name"
          item-value="code"
          placeholder="Issuing Country:Optioanl"
          persistent-hint
          name="issue-country-for-passports"
          required
          outlined
          prepend-inner-icon="mdi-flag"
          hide-no-data
          color="blueDark"
          autocomplete="off"
          :menu-props="{ auto: true, maxWidth: 200, overflowY: true }"
          id="passenger-passport-issue-country"
          :rules="[v => !!v || 'This field is required']"
          ></v-autocomplete>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blueDark" dark large tile elevation="0" @click="savePassengerPassportInfo" :loading="saveLoad">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog  max-width="500" v-model="issueRequestDialog">
      <v-card max-width="500" v-if="user.subAgent" class="pa-5">
        <v-snackbar id="snackbar" v-model="snackbar" :color="color" top :timeout="5000">
          <v-row>
            {{ text }}
            <v-spacer></v-spacer>
            <v-btn
              dark
              icon
              @click="snackbar = false"
            >
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-snackbar>
        <v-card-title class="px-0">Request Issue</v-card-title>
        <v-select :items="user.subAgent.agents_emails" class="mb-5" hide-details v-model="selectedEmail" outlined label="Choose agent to issue"></v-select>
        <v-text-field v-model="emailToAdd" :rules="[v => (/^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/.test(v) || v === '') || 'E-mail must be valid']" outlined label="Add Email" hint="Add email to emails list" persistent-hint append-icon="mdi-plus-circle" @click:append="addEmail"  @keyup.enter="addEmail"></v-text-field>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn tile elevation="0" color="blueDark white--text" :disabled="!selectedEmail" @click="requestIssue" :loading="loadRequestBtn">Request</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <div v-if="details.payment_type === 'Cash'" class="mt-5">
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header class="secondary--text text-h6">
            Add credit card
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-form v-model="validPayment" ref="paymentForm">
              <address-card />
              <v-card class="pa-5 mt-5" outlined>
                <v-card-title>Credit Card Informatio</v-card-title>
                <credit @holder="setCardHolder" @card="setCardData" @expire="setCardExpiry" @cvv="setCVV" />
              </v-card>
              <v-btn color="blueDark" dark large tile elevation="0" class="mt-3 px-15" right @click="saveCardData" :loading="saveCardLoad">Save</v-btn>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div> -->

    <h3 class="secondary--text mt-5">Flight Segments</h3>
    <hr class="hor">
    <v-row class="" v-for="(segment, i) in details.flight_segments" :key="segment.id">
      <v-card class="px-5 ma-3 mt-5" width="100%">
        <h3 class="secondary--text my-2">Segment {{i + 1}}</h3>
        <v-simple-table dense style="width: 100%;">
          <template v-slot:default>
            <thead>
                <tr>
                    <th class="text-left">Airline</th>
                    <th class="text-left">Flight NO.</th>
                    <th class="text-left">Duration</th>
                    <th class="text-left">From</th>
                    <th class="text-left">To</th>
                    <th class="text-left">Status</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ segment.airline }}</td>
                    <td>{{ segment.flight_number }}</td>
                    <td>{{ segment.flight_duration }}h</td>
                    <td>
                      {{ segment.departure_location }}
                      <br>
                      {{formatDateTime(segment.departure_date)}}, {{segment.departure_time}}
                    </td>
                    <td>
                      {{ segment.arrival_location }}
                      <br>
                      {{formatDateTime(segment.arrival_date)}}, {{segment.arrival_time}}
                    </td>
                    <td>
                      {{segment.status.name}}
                    </td>
                </tr>
            </tbody>
          </template>
        </v-simple-table>
        </v-card>
    </v-row>
  </v-container>
</template>

<script>
import { countries } from '../contants'
import cities from './citiesAutocomplete.vue'
import picker from './datePicker.vue'
import { mangeAgentEmails, issueRequest, cancelFlight, preRefund, quoteIssue, issuePnr, headersAuth, refundPnr, checkExchangeValidity, searchExchangeOffer, quoteExchangeOffer, confirmExchangeOffer, updatePassportInfo } from '../links'
// import credit from '../components/credit'
// import addressCard from '../components/address info.vue'
import { mapState } from 'vuex'
import ExchangeFlightCard from './ExchangeFlightCard.vue'

export default {
  props: ['details'],
  components: {
    cities,
    picker,
    ExchangeFlightCard
  },
  data () {
    return {
      passengerInfo: null,
      passportFormDialog: false,
      validPassport: true,
      saveLoad: false,
      saveCardLoad: false,
      creditInfo: {
        creditCardNumber: '',
        creditCardExpireDate: '',
        creditCardType: '',
        cvv: '',
        creditCardHolderName: ''
      },
      validPayment: true,
      snackbar: false,
      mainSnackbar: false,
      color: '',
      text: '',
      loadCancelBtn: false,
      loadRequestBtn: false,
      issueRequestDialog: false,
      selectedEmail: '',
      emailToAdd: '',
      preConfirmRefundDialog: false,
      confirmRefundDialog: false,
      preConfirmBtnLoading: false,
      refundResponse: null,
      loadingRefund: false,
      searchDialog: false,
      searchResultDialog: false,
      deletedFlight: null,
      journeys: [],
      paxIds: [],
      selectedAction: null,
      journeys_cancel: [],
      journeys_replace: [],
      flightResult: [],
      qouteReservedPnr: false,
      price: null,
      currency: null,
      paymentMethodForConfirm: 'cash',
      validCard: true,
      cardNum: null,
      cardName: null,
      cardExpireDate: '',
      loadingConfirmPnr: null,
      cardCode: '',
      menu: false,
      menu2: false,
      cvv: null,
      country_code: null,
      country: null,
      state: null,
      city: null,
      street: null,
      zipCode: null,
      loadingQuotePnr: false,
      checkAvalibiltyLoading: false,
      cardNameRules: [
        v => !!v || 'Card number is required'
      ],
      cardRules: [
        v => !!v || 'Card number is required',
        v => (!isNaN(v)) || 'Card number must be only numbers',
        v => v.length > 12 || 'Card number must be at least 13 characters',
        v => v.length < 20 || 'Card number must be at most 19 characters',
        v => this.vllidateCard(v) || 'Please enter a valid card number'
      ],
      cvvRules: [
        v => !!v || 'CVV is required',
        v => (!isNaN(v)) || 'CVV must be only numbers',
        v => v.length > 2 || 'CVV must be at least 3 characters',
        v => v.length < 5 || 'CVV must be at most 4 characters'
      ],
      requiredRule: [
        v => !!v || 'Field is required'
      ],
      searchFlightLoading: false,
      quoteExchangeDialog: false,
      newOffer: null,
      paymentMethod: 'cash',
      menuOfExchange: false,
      cardNumOfExchangr: null,
      cardNameOfExchange: null,
      cardExpireDateOfExchange: null,
      cvvOfExchange: null,
      countryOfExchange: null,
      stateOfExchnage: null,
      cityOfExchange: null,
      zipCodeOfExchange: null,
      streetOfExchange: null,
      loadingConfirmExchange: false,
      newFlight: null,
      confirmExchangeDialog: false
    }
  },
  computed: {
    validJourneys () {
      return this.journeys.filter((trip) => !trip.segmentRefs[0].startsWith('X'))
    },
    cardExpireDateText () {
      if (this.cardExpireDate) return this.formatDate(this.cardExpireDate)
      else return ''
    },
    cardExpireDateTextOfExchange () {
      if (this.cardExpireDateOfExchange) return this.formatDate(this.cardExpireDateOfExchange)
      else return ''
    },
    countries () {
      return countries
    },
    ...mapState(['user'])
  },
  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month] = date.split('-')
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      return `${months[month - 1]} ${year}`
    },
    formatExpiryDate (date, i, type) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      const shortYear = year.slice(-2) // 👈 get last 2 digits

      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

      const newDate = `${day} ${months[month - 1]} ${shortYear}`

      if (day) {
        type === 'passport'
          ? this.passExpireDateText[i] = newDate
          : this.dateOfBirthText[i] = newDate
      } else {
        return `${month}/${shortYear}`
      }
    },
    formatDateTime (date) {
      return new Date(date).toLocaleString()
    },
    openPassportForm (passenger) {
      this.passengerInfo = JSON.parse(JSON.stringify(passenger))
      this.passportFormDialog = true
    },
    passportMinExpireDate () {
      const lastFlightSegment = this.details.flight_segments[this.details.flight_segments.length - 1]
      console.log(lastFlightSegment)
      const lastArrivalDate = lastFlightSegment.arrival_date
      const today = new Date(lastArrivalDate)
      today.setMonth(today.getMonth() + 6)
      return today
    },
    minExpireDateRange (date) {
      return date < new Date(this.passportMinExpireDate())
    },
    changeInputColor (id, color) {
      document.getElementById(id).style.borderColor = color
    },
    setCardData (number, type) {
      this.creditInfo.creditCardNumber = number
      switch (type) {
        case 'visa':
          this.creditInfo.creditCardType = 'VI'
          break
        case 'mastercard':
          this.creditInfo.creditCardType = 'CA'
          break
        case 'american-express':
          this.creditInfo.creditCardType = 'AX'
          break
        case 'discover':
          this.creditInfo.creditCardType = 'DS'
          break
        case 'diners-club':
          this.creditInfo.creditCardType = 'DN'
          break
        default:
          this.creditInfo.creditCardType = type
          break
      }
    },
    setCardExpiry (date) {
      this.creditInfo.creditCardExpireDate = date
    },
    setCVV (cvv) {
      this.creditInfo.cvv = cvv
    },
    setCardHolder (name) {
      this.creditInfo.creditCardHolderName = name
    },
    savePassengerPassportInfo (passenger) {
      this.$refs.passportForm.validate()
      if (this.validPassport && this.passengerInfo.passport_expire_date) {
        console.log('step1')
        this.saveLoad = true
        const body = {
          pnr: this.details.booking_reference,
          passenger_id: this.passengerInfo.id,
          passport: {
            number: this.passengerInfo.passport_number,
            issue_country: this.passengerInfo.passport_issue_country,
            expiry_date: this.passengerInfo.passport_expire_date
          }
        }
        const token = this.$store.state.user
        const header = { headers: headersAuth(token) }
        this.$http.post(updatePassportInfo(), body, header).then(response => {
          if (response.data.status) {
            this.details.passenger_details[this.details.passenger_details.findIndex(el => el.id === this.passengerInfo.id)].passport_number = this.passengerInfo.passport_number
            this.details.passenger_details[this.details.passenger_details.findIndex(el => el.id === this.passengerInfo.id)].passport_issue_country = this.passengerInfo.passport_issue_country
            this.details.passenger_details[this.details.passenger_details.findIndex(el => el.id === this.passengerInfo.id)].passport_expire_date = this.passengerInfo.passport_expire_date
            this.$store.commit('showFeedback', { text: response.body.message, color: 'success' })
          } else {
            this.$store.commit('showFeedback', { text: response.body.message, color: 'error' })
          }
        }).catch(err => {
          this.$store.commit('showFeedback', { text: err.data.message, color: 'error' })
        }).finally(() => {
          this.saveLoad = false
          this.passportFormDialog = false
          this.$refs.passportForm.reset()
        })
      } else {
        this.$store.commit('showFeedback', { text: 'Please fill all fields', color: 'error' })
      }
    },
    // saveCardData () {
    //   this.$refs.paymentForm.validate()
    //   if (this.validPayment) {
    //     this.$store.dispatch('setWrittenAddress', document.getElementById('card-address').value)
    //     this.saveCardLoad = true
    //     var body = {
    //       reference_number: this.details.booking_reference,
    //       creditCardNumber: this.creditInfo.creditCardNumber,
    //       creditCardExpireDate: this.creditInfo.creditCardExpireDate,
    //       creditCardType: this.creditInfo.creditCardType,
    //       creditCardHolderName: this.creditInfo.creditCardHolderName,
    //       cvv: this.creditInfo.cvv,
    //       zipCode: this.$store.state.zipCode,
    //       address: this.$store.state.writtenAddress,
    //       streetLine: this.streetLine,
    //       city: this.$store.state.writtenCity,
    //       state: this.$store.state.writtenState,
    //       countryISO: this.$store.state.writtenCountry,
    //       kountSessionId: sessionStorage.getItem('kountSessionId')
    //     }

    //     this.$http.post(addCreditCard, body, { headers: headers(this.$cookies.get('userToken')) }).then(response => {
    //       console.log(response.data)
    //       if (response.data.status) {
    //         this.details.payment_type = 'Credit Card'
    //         this.mainSnackbar = true
    //         this.color = 'success'
    //         this.text = 'Passport information updated successfully'
    //         this.$emit('updateBookings')
    //       } else {
    //         this.mainSnackbar = true
    //         this.color = 'error'
    //         this.text = response.data.message
    //       }
    //     }).catch(err => {
    //       this.mainSnackbar = true
    //       this.color = 'error'
    //       this.text = err.data.message
    //     }).finally(() => {
    //       this.saveCardLoad = false
    //       // this.$refs.paymentForm.reset()
    //     })
    //   } else {
    //     this.mainSnackbar = true
    //     this.color = 'warning'
    //     this.text = 'Please fill all fields'
    //   }
    // },
    cancelFlight () {
      this.loadCancelBtn = true
      this.$http.post(cancelFlight, { pnr: this.details.pnr_id }, { headers: headersAuth(this.$cookies.get('userToken')) }).then(response => {
        if (response.body.status) {
          this.mainSnackbar = true
          this.color = 'success'
          this.text = 'Flight cancelled'
          this.details.status.status = 'Cancelled'
        } else {
          this.mainSnackbar = true
          this.color = 'error'
          this.text = response.body.message
        }
      }).catch(err => {
        this.disableCancelBtn = false
        this.mainSnackbar = true
        this.color = 'error'
        this.text = err.body.message
      }).finally(() => {
        this.loadCancelBtn = false
      })
    },
    addEmail () {
      if (this.emailToAdd) {
        const emails = this.user.subAgent.agents_emails
        emails.push(this.emailToAdd)
        this.$http.post(mangeAgentEmails, { emails: emails }, { headers: headersAuth(this.$cookies.get('userToken')) }).then(response => {
          this.snackbar = true
          this.color = 'success'
          this.text = 'Emails Updated'
          this.user.subAgent.agents_emails = response.body.data
        }).catch(err => {
          this.snackbar = true
          this.color = 'error'
          this.text = err.body.message
        }).finally(() => {
          this.emailToAdd = ''
        })
      } else {
        this.snackbar = true
        this.color = 'warning'
        this.text = 'Please add email at first'
      }
    },
    requestIssue () {
      if (this.selectedEmail) {
        const payload = {
          agent_email: this.selectedEmail,
          booking_reference: this.details.booking_reference
        }
        this.loadRequestBtn = true
        this.$http.post(issueRequest, payload, { headers: headersAuth(this.$cookies.get('userToken')) }).then(response => {
          this.mainSnackbar = true
          this.color = 'success'
          this.text = 'Request Sent'
        }).catch(err => {
          this.snackbar = true
          this.color = 'error'
          this.text = err.body.message
        }).finally(() => {
          this.loadRequestBtn = false
          this.issueRequestDialog = false
        })
      }
    },
    confirmRefundPnr () {
      this.preConfirmBtnLoading = true
      const token = this.$store.state.user
      const header = { headers: headersAuth(token) }
      const body = { pnr: this.details.booking_reference }

      this.$http.post(preRefund, body, header).then(response => {
        this.preConfirmBtnLoading = false
        console.log(response)
        if (response.body.status === false) {
          this.$store.commit('showFeedback', { text: response.body.message, color: 'error' })
        } else {
          if (response.body.data.errors && response.body.data.ndc.errors.length) {
            this.$store.commit('showFeedback', { text: response.body.data.ndc.errors, color: 'error' })
          }
          this.$store.commit('showFeedback', { text: response.body.message, color: 'success' })
          this.refundResponse = response.body.data
          this.confirmRefundDialog = true
        }
      })
    },
    refundPnr () {
      this.loadingRefund = true
      const token = this.$store.state.user
      const header = { headers: headersAuth(token) }
      const body = {
        pnr: this.details.booking_reference,
        cancelled_offer_id: this.refundResponse.ndc.offerId
      }

      this.$http.post(refundPnr, body, header).then(response => {
        this.loadingRefund = false
        console.log(response)
        if (response.body.status === false) {
          this.$store.commit('showFeedback', { text: response.body.message, color: 'error' })
        } else {
          this.$store.commit('showFeedback', { text: response.body.message, color: 'success' })
          this.confirmRefundDialog = false
          this.preConfirmRefundDialog = false
        }
      })
    },
    cancelSearch () {
      this.searchDialog = false
      this.deletedFlight = null
      this.selectedAction = null
      this.journeys_cancel = []
      this.journeys_replace = []
    },
    qoutePnr () {
      this.loadingQuotePnr = true
      const token = this.$store.state.user
      const header = { headers: headersAuth(token) }
      const body = { pnr: this.details.booking_reference }

      this.$http.post(quoteIssue, body, header).then(response => {
        this.loadingQuotePnr = false
        if (response.body.status === false) {
          this.$store.commit('showFeedback', { text: response.body.message, color: 'error' })
        } else {
          if (response.body.data.ndc && response.body.data.ndc.errors.length) {
            this.$store.commit('showFeedback', { text: response.body.data.ndc.errors, color: 'error' })
          }
          this.$store.commit('showFeedback', { text: response.body.message, color: 'success' })
          this.qouteReservedPnr = true
          this.price = response.body.data.ndc.totalPrice.price
          this.currency = response.body.data.ndc.totalPrice.currency
        }
      })
    },
    confirmPnr () {
      this.loadingConfirmPnr = true
      const token = this.$store.state.user
      const header = { headers: headersAuth(token) }
      let body
      if (this.paymentMethodForConfirm === 'card') {
        const paymentCard = {
          card_number: this.cardNum,
          card_expiration_date: this.formatExpiryDate(this.cardExpireDate, 0, 'expire'),
          cvv: this.cvv,
          card_holder_name: this.cardName,
          country: this.country.name,
          country_code: this.country.code,
          state: this.state,
          city: this.city,
          postal_code: this.zipCode,
          street: this.street
        }
        body = {
          pnr: this.details.booking_reference,
          new_amount: this.price,
          payment_card: paymentCard
        }
      } else {
        body = {
          pnr: this.details.booking_reference,
          new_amount: this.price
        }
      }
      console.log('test1', body)
      this.$http.post(issuePnr, body, header).then(response => {
        this.loadingConfirmPnr = false
        if (response.body.status === false) {
          this.$store.commit('showFeedback', { text: response.body.message, color: 'error' })
        } else {
          this.qouteReservedPnr = false
          this.$store.commit('showFeedback', { text: response.body.message, color: 'success' })
        }
      })
    },
    checkValibility () {
      this.checkAvalibiltyLoading = true
      const token = this.$store.state.user
      const header = { headers: headersAuth(token) }
      const body = { pnr: this.details.booking_reference }
      this.$http.post(checkExchangeValidity, body, header).then(response => {
        this.checkAvalibiltyLoading = false
        if (response.body.status) {
          if (response.body.data.ndc.errors.length) {
            this.$store.commit('showFeedback', { text: response.body.data.ndc.error, color: 'error' })
          }
          if (response.body.data.ndc.warnings.length) {
            this.$store.commit('showFeedback', { text: response.body.data.ndc.warnings, color: 'error' })
          }
          this.$store.commit('showFeedback', { text: response.body.message, color: 'success' })
          this.journeys = response.body.data.ndc.journeys
          console.log('journeys', this.journeys)
          this.paxIds = response.body.data.ndc.paxRefs
          this.searchDialog = true
        }
      })
    },
    deleteFlight (code, index) {
      this.deletedFlight = index
      this.journeys_cancel.push(code)
      this.selectedAction = null
      this.journeys_replace = []
    },
    searchFlights () {
      if (this.selectedAction === 'going') {
        this.journeys_replace.push(this.validJourneys[0].journeyId)
      } else if (this.selectedAction === 'return') {
        this.journeys_replace.push(this.validJourneys[1].journeyId)
      } else if (this.selectedAction === 'round') {
        this.journeys_replace.push(this.validJourneys[0].journeyId)
        this.journeys_replace.push(this.validJourneys[1].journeyId)
      }
      this.searchFlightLoading = true
      const token = this.$store.state.user
      const header = { headers: headersAuth(token) }
      const searchStore = this.$store.state
      if (this.journeys_replace.length) {
        const body = {
          pnr: this.details.booking_reference,
          tripType: this.selectedAction === 'round' ? 'round' : 'one',
          origin: searchStore.airports.departureAirports[0].Code,
          originType: searchStore.airports.departureAirports[0].Type,
          destination: searchStore?.airports?.arrivalAirports[0]?.Code,
          destinationType: searchStore?.airports?.arrivalAirports[0]?.Type,
          departureDate: searchStore.flightDates.departureDates[0],
          arrivalDate: searchStore.flightDates.arrivalDate
        }
        this.$http.post(searchExchangeOffer, body, header).then(response => {
          this.searchFlightLoading = false
          if (response.body.status) {
            if (response.body.data.errors.length) {
              this.$store.commit('showFeedback', { text: response.body.data.errors, color: 'error' })
            }
            this.flightResult = response.body.data.flights
            console.log(this.flightResult)
            this.searchResultDialog = true
          } else {
            this.$store.commit('showFeedback', { text: response.body.message, color: 'error' })
          }
        })
      } else {
        const exchangeBody = {
          pnr: this.details.booking_reference,
          journeys_cancel: this.journeys_cancel,
          journeys_replace: this.journeys_replace,
          new_offers: []
        }
        this.$http.post(quoteExchangeOffer, exchangeBody, header).then(response => {
          this.searchFlightLoading = false
          if (response.body.data.ndc.errors?.length) {
            response.body.data.ndc.errors.forEach(err => {
              this.$store.commit('showFeedback', { text: err.text, color: 'error' })
            })
          } else {
            this.newOffer = response.body.data.ndc
            this.quoteExchangeDialog = true
          }
        })
      }
    },
    selectFlight (data) {
      console.log('test new offer', data)
      this.newOffer = data
      this.quoteExchangeDialog = true
      const expireTime = new Date(data.offerExpiredAt).getTime()
      const now = Date.now()
      const remainingTime = expireTime - now
      console.log('test remaning time', remainingTime)
      setTimeout(() => {
        this.$store.commit('setFlightTimeOut', true)
      }, remainingTime)
    },
    confirmOffer () {
      console.log('details', this.details)
      this.loadingConfirmExchange = true
      const token = this.$store.state.user
      const header = { headers: headersAuth(token) }
      let body
      if (this.paymentMethod === 'card') {
        body = {
          pnr: this.details.booking_reference,
          first_name: this.details.passenger_details[0].first_name,
          surname: this.details.passenger_details[0].last_name,
          offer: {
            offer_id: this.newOffer.offerId,
            offer_items: this.newOffer.offerItems.map(
              ({ pax_ref_id: paxRefId, ...rest }) => ({
                ...rest,
                pax_ref_ids: [paxRefId]
              })
            ),
            amount_to_pay: this.newOffer.dueToAirline,
            currency: this.newOffer.dueCurrency
          },
          payment_card: {
            card_number: this.cardNumOfExchangr,
            card_name: this.cardNameOfExchange,
            card_expiration_date: this.cardExpireDateOfExchange,
            cvv: this.cvvOfExchange,
            country: this.countryOfExchange.name,
            country_code: this.countryOfExchange.code,
            state: this.stateOfExchnage,
            city: this.cityOfExchange,
            postal_code: this.zipCodeOfExchange,
            street: this.streetOfExchange
          },
          with_payment: true
        }
      } else {
        body = {
          pnr: this.details.booking_reference,
          first_name: this.details.passenger_details[0].first_name,
          surname: this.details.passenger_details[0].last_name,
          offer: {
            offer_id: this.newOffer.offerId,
            offer_items: this.newOffer.offerItems.map(
              ({ pax_ref_id: paxRefId, ...rest }) => ({
                ...rest,
                pax_ref_ids: [paxRefId]
              })
            ),
            amount_to_pay: this.newOffer.dueToAirline,
            currency: this.newOffer.dueCurrency
          },
          with_payment: true
        }
      }
      this.$http.post(confirmExchangeOffer, body, header).then(response => {
        this.loadingConfirmExchange = false
        if (response.body.data.ndc.errors?.length) {
          response.body.data.ndc.errors.forEach(err => {
            this.$store.commit('showFeedback', { text: err.text, color: 'error' })
          })
        } else {
          this.newFlight = response.body.data.ndc
          this.loadingConfirmExchange = false
          this.quoteExchangeDialog = false
          this.searchResultDialog = false
          this.searchDialog = false
          this.confirmExchangeDialog = true
        }
      })
    }
  }
}
</script>

<style>
  .hor {
    border: none;
    height: 2px;
    width: 169px;
    background-color: #DF731C;
    margin: 15px 0;
  }
  .mx-input {
    width: 100%;
    height: 56px !important;
    border-color: #9e9e9e;
    margin-bottom: 20px !important;
  }
</style>
